import { BaseRestRepository } from '~/repositories/baseRestRepository';
import { envConfig } from '~/utils/env';
import type { ACHPaymentProcessingSettings } from '~/swagger/settings/Api';

const SETTINGS_BASE_URL = `${envConfig.service.settings}/company-portal/settings`;
const ACH_PAYMENT_PROCESSING_SETTINGS_URL = `${SETTINGS_BASE_URL}/achpaymentprocessing`;

export class achPaymentProcessingSettingsRepository extends BaseRestRepository {
  public async changeAchPaymentProcessingSettings(payload: ACHPaymentProcessingSettings) {
    const url = `${ACH_PAYMENT_PROCESSING_SETTINGS_URL}/company`;
    const response = await this.fetchWithAuth(url, {
      method: 'POST',
      body: JSON.stringify({ settings: payload }),
    });
    return this.getJsonResponse(response);
  }

  public async getAllAchPaymentProcessingSettings() {
    const url = `${ACH_PAYMENT_PROCESSING_SETTINGS_URL}/with-overrides`;
    const response = await this.fetchWithAuth(url);
    return this.getJsonResponse(response);
  }

  public async updateAchPaymentProcessingSettingsByLevel(level: string, levelId: string, payload: ACHPaymentProcessingSettings) {
    const url = ACH_PAYMENT_PROCESSING_SETTINGS_URL;
    const response = await this.fetchWithAuth(url, {
      method: 'POST',
      body: JSON.stringify({ settings: payload, targets: [{ level, levelId }] }),
    });
    return this.getJsonResponse(response);
  }

  public async deleteAchPaymentProcessingSettingsByLevel(level: string, levelId: string) {
    const url = `${ACH_PAYMENT_PROCESSING_SETTINGS_URL}/${level}/${levelId}`;
    await this.fetchWithAuth(url, {
      method: 'DELETE',
    });
  }
}
